import React from 'react';
import cls from './DeleteAnnouncementModal.module.scss';
import { Modal, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../../hooks/defaultHooks';
import { closeModal } from '../../../store/slices/modalSlice';
import { useDeleteAnnouncementMutation } from '../../announcement/announcement.service';
import { modalExtra } from '../../../selectors/selectors';
import { toast } from 'react-toastify';
import { isFetchBaseQueryError } from '../../../utils/helpers';

const DeleteAnnouncementModal = () => {
  const dispatch = useAppDispatch();
  const extraModal = useAppSelector(modalExtra);
  const [deleteAnnouncement] = useDeleteAnnouncementMutation();
  const closeHandler = () => {
    dispatch(closeModal());
  };
  const deleteAnnouncementHandler = async () => {
    try {
      if (extraModal?.handler) {
        await deleteAnnouncement({ announcementId: extraModal?.id ?? '' }).unwrap();
        extraModal.handler();
        toast.success('Announcement deleted');
        dispatch(closeModal());
      }
    } catch (error) {
      if (isFetchBaseQueryError(error)) {
        if (error.status === 400) {
          toast.error('Please try again later');
        } else if (error.status === 403) {
          toast.error('Access denied');
        }
      }
    }
  };
  return (
    <>
      <Modal.Header className={cls.ModalHeader} data-testid="modal-title" closeButton>
        <h3 className="title-3">Delete Announcement?</h3>
      </Modal.Header>
      <Modal.Body className={cls.ModalBody}>
        <div>
          <span>
            Are you sure you want to delete the announcement{' '}
            <strong className={cls.TextInformation}>{extraModal?.textInformation}</strong>
            <br />
          </span>
          <span>Users will no longer see this announcement.</span>
        </div>
        <div className={cls.Buttons}>
          <Button type="button" className={cls.DeleteButton} onClick={deleteAnnouncementHandler}>
            Delete
          </Button>
          <Button className={cls.CancelButton} onClick={closeHandler}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </>
  );
};

export default DeleteAnnouncementModal;
